import React from 'react';
import { FormLabel, Text } from "@chakra-ui/react";

const CustomFormLabel = ({ children, isRequired, ...props }) => (
  <FormLabel {...props}>
    {children} {isRequired && <Text as="span" color="red.500">*</Text>}
  </FormLabel>
);

export default CustomFormLabel;